<template>
    <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        data-om-id="28c121e1:49"
    >
        <path
            d="M6 4H18A2 2 0 0 1 20 6V15A2 2 0 0 1 18 17H11L7 21V17H6A2 2 0 0 1 4 15V6A2 2 0 0 1 6 4Z"
            data-om-id="28c121e1:50"
        ></path>
        <path d="M8 9h8M8 12.5h5" data-om-id="28c121e1:51"></path>
    </svg>
</template>
